export const BASE_URL = "https://nopser.tutorazzi.com/api"; 

export const LOGIN_URL = `${BASE_URL}/admin/auth/login`;
export const REGISTER_URL = `${BASE_URL}/admin/auth/register`;

export const GET_APPLICATIONS = `${BASE_URL}/admin/application`;
export const EDIT_APPLICATION = (applicationId) => `${BASE_URL}/admin/application/${applicationId}/edit`;

export const GET_RESEARCHES = `${BASE_URL}/admin/research`;
export const GET_RESEARCHES_DETAIL = (researchId) => `${BASE_URL}/admin/research/${researchId}/show`;
export const DOWNLOAD_REPORT = `${BASE_URL}/admin/report`;
export const CREATE_RESEARCH = `${BASE_URL}/admin/research`;
export const UPDATE_RESEARCH = (researchId) => `${BASE_URL}/admin/research/${researchId}/edit`;
export const DELETE_RESEARCH = (researchId) => `${BASE_URL}/admin/research/${researchId}/close`;

export const GET_DASHBOARD_GRAPH = `${BASE_URL}/admin/dashboard/applications-over-time`;
export const GET_DASHBOARD_TILES = `${BASE_URL}/admin/dashboard/tiles-stats`;

export const GET_PROFILE_URL = `${BASE_URL}/admin/account`;
export const UPDATE_PROFILE_URL = `${BASE_URL}/admin/account/complete`;
export const UPDATE_PROFILE_PIC_URL = `${BASE_URL}/admin/account/profile`;

export const GET_CATEGORIES = `${BASE_URL}/admin/categories`;

export const GET_FORMS = `${BASE_URL}/admin/form`;
export const GET_FORMS_DETAIL = (formId) => `${BASE_URL}/admin/form/${formId}/show`;
export const UPDATE_FORM = (formId) => `${BASE_URL}/admin/form/${formId}/edit`;
export const CREATE_FORMS = `${BASE_URL}/admin/form/add`;

export const GET_RESPONDENTS = `${BASE_URL}/admin/respondents`;
export const GET_RESPONDENTS_DETAIL = (userId) => `${BASE_URL}/admin/respondents/${userId}/profile`;
export const GET_RESPONDENTS_TILE = `${BASE_URL}/admin/respondents/tiles`;

export const GET_RESEARCHERS = `${BASE_URL}/admin/researchers`;
export const GET_RESEARCHERS_DETAIL = (userId) => `${BASE_URL}/admin/researchers/${userId}/profile`;
export const GET_RESEARCHERS_TILE = `${BASE_URL}/admin/researchers/tiles`;

export const GET_PUSH_NOTIFICATION = `${BASE_URL}/admin/notification`;
export const ADD_PUSH_NOTIFICATION = `${BASE_URL}/admin/notification/push`;
export const scheduleNotification = (notificationId) => `${BASE_URL}/admin/notification/${notificationId}/schedule`;

export const GET_TRANSACTIONS = `${BASE_URL}/admin/wallet`;
export const UPDATE_TRANSACTION_STATUS = (transactionId) => `${BASE_URL}/admin/wallet/${transactionId}/status`;

export const UPLOAD_IMAGE = `${BASE_URL}/master/file/upload`;
